import { Directive, EmbeddedViewRef, inject, Input, TemplateRef, ViewContainerRef } from "@angular/core";

import { PermissionsService } from "@intocare/auth-data";

type Permissions = string[] | { $or: string[] } | ({ $or: string[] } | string)[];

/** Based upon `*ngIf`. See https://github.com/angular/angular/blob/master/packages/common/src/directives/ng_if.ts. */
@Directive({
	selector: "[userHasPermission]",
})
export class HasPermissionDirective {
	private permissionsService = inject(PermissionsService);
	private viewContainer = inject(ViewContainerRef);

	private requiredPermissions: Permissions = [];

	private thenTemplateRef: TemplateRef<unknown> | null = null;
	private thenViewRef: EmbeddedViewRef<unknown> | null = null;
	private elseTemplateRef: TemplateRef<unknown> | null = null;
	private elseViewRef: EmbeddedViewRef<unknown> | null = null;

	constructor() {
		const templateRef = inject<TemplateRef<unknown>>(TemplateRef);

		this.thenTemplateRef = templateRef;
	}

	@Input({ alias: "userHasPermission" })
	set hasPermission(permissions: Permissions) {
		this.requiredPermissions = permissions;
		this.updateView();
	}

	@Input()
	set userHasPermissionElse(ngTemplate: TemplateRef<unknown>) {
		this.elseTemplateRef = ngTemplate;
		this.elseViewRef = null;
		this.updateView();
	}

	private updateView() {
		const hasPermissions = this.permissionsService.userHasPermissions(this.requiredPermissions);

		if (hasPermissions) {
			if (!this.thenViewRef) {
				this.viewContainer.clear();
				this.elseViewRef = null;

				if (this.thenTemplateRef) {
					this.thenViewRef = this.viewContainer.createEmbeddedView(this.thenTemplateRef);
				}
			}
		} else {
			if (!this.elseViewRef) {
				this.viewContainer.clear();
				this.thenViewRef = null;

				if (this.elseTemplateRef) {
					this.elseViewRef = this.viewContainer.createEmbeddedView(this.elseTemplateRef);
				}
			}
		}
	}
}
